export const CANAL_OPTIONS = [
  { label: "Téléphone", value: 0 },
  { label: "Mail", value: 1 },
  { label: "FioManager", value: 2 },
  { label: "Interne", value: 3},
  { label: "Audit", value: 4 },
];

export const DELAI_RESOLUTION_OPTIONS = [
  { label: "Immédiatement", value: 0 },
  { label: "Moins d'une heure", value: 1 },
  { label: "Moins d'une demi-journée", value: 2 },
  { label: "Moins d'une journée", value: 3 },
  { label: "Plus d'une journée", value: 4 },
];

export const CANAL_OPTIONS_STRINGS = [
  { label: "Téléphone", value: "0" },
  { label: "Mail", value: "1" },
  { label: "FioManager", value: "2" },
  { label: "Interne", value: "3"},
  { label: "Audit", value: "4" },
];

export const DELAI_RESOLUTION_OPTIONS_STRINGS = [
  { label: "Immédiatement", value: "0" },
  { label: "Moins d'une heure", value: "1" },
  { label: "Moins d'une demi-journée", value: "2" },
  { label: "Moins d'une journée", value: "3" },
  { label: "Plus d'une journée", value: "4" },
];

export const RATE_OPTIONS = [
  // { label : "0.5 étoile", value: 0.5 },
  { label: "1 étoile", value: 1 },
  // {label : "1.5 étoiles", value: 1.5},
  { label: "2 étoiles", value: 2 },
  // {label : "2.5 étoiles", value: 2.5},
  { label: "3 étoiles", value: 3 },
  // {label : "3.5 étoiles", value: 3.5},
  { label: "4 étoiles", value: 4 },
  // {label : "4.5 étoiles", value: 4.5},
  { label: "5 étoiles", value: 5 },
];